export const DIMENTIONS_GAME = {
  mobile: {
    X: 375,
    Y: 550,
  },
  desktop: {
    X: 1000,
    Y: 500,
  },
}

export const SCENE_PARAMETERS = {
  UTERO: {
    POINTS_TO_ACTION: 1, // + , -
    TIME_LIMIT: 60, // seg
    FOOD_ADD_DELAY: 950,
    FOOD_VELOCITY: 120,
  },
  PUBERTAD: {
    LIVES: 3, // + , -
    TIME_LIMIT: 60, // seg
    POINTS_TO_TIME: 1, // +
    MOON_ROTARION: -0.01,
    GRAVITY: 1000,
    PERSONAJE_JUMP_VELOCITY_Y: 1000 * -0.5,
    PERSONAJE_BODY_WIDTH_FACTOR: 0.5,
    EMOJI_ADD_DELAY: 1300,
    EMOJI_VELOCITY_X: -350,
  },
  FLUJO: {
    GRAVITY: 100,
    TIME_LIMIT: 60, // seg
    GOUTS_ADD_FRECUENCE: 800,
    POINTS_TO_ACTION: 1,
    POINTS_TO_BONUS: 2,
  },
}
